declare global {
  interface Window {
    dataLayer?: object[];
  }
}

export const getOrCreateDataLayer = () =>
  (window.dataLayer = window.dataLayer || []);
